import { PolicyTemplate, PolicyTemplateStaticCategory } from '../../../types/policies';
import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CreateFromTemplate from './CreateFromTemplate';
import TemplatesList from './components/TemplatesList';
import { usePolicyTemplatesContext } from './context/PolicyTemplatesContext';

interface TemplatesRoutesProps {
    selectedCategory: string;
}

const getTemplatesToDisplay = (templates: PolicyTemplate[], selectedCategoryId: string) => {
    if (selectedCategoryId === PolicyTemplateStaticCategory.FAVORITES)
        return templates.filter((template) => template.isFavorite);

    return templates.filter((template) => template.typeId === selectedCategoryId);
};

const TemplatesRoutes: FC<TemplatesRoutesProps> = ({ selectedCategory }) => {
    const match = useRouteMatch();
    const { templates } = usePolicyTemplatesContext();
    const templatesToDisplay = getTemplatesToDisplay(templates, selectedCategory);

    return (
        <>
            {/* @ts-ignore - TODO: try to solve by upgrading react-router-dom or with: https://github.com/facebook/react/issues/24304#issuecomment-1092563688*!/*/}
            <Switch>
                {/* @ts-ignore - TODO: try to solve by upgrading react-router-dom or with: https://github.com/facebook/react/issues/24304#issuecomment-1092563688*!/*/}
                <Route path={`${match.path}/Create/:templateId`} component={CreateFromTemplate} />
                {/* @ts-ignore - TODO: try to solve by upgrading react-router-dom or with: https://github.com/facebook/react/issues/24304#issuecomment-1092563688*!/*/}
                <Route path={match.path}>
                    <TemplatesList categoryId={selectedCategory} templates={templatesToDisplay} />
                </Route>
            </Switch>
        </>
    );
};

export default TemplatesRoutes;
